import {
  GetJobList,
  UploadJobFile,
  FilePre,
  DelJob,
  GetUserJoibList,
  GetJoibStatus,
  GetJobPinCode
} from "../../api/job";
export default {
  state: {},
  getters: {},
  actions: {
    GetJobList({ commit }, payload) {
      return new Promise(resolve => {
        GetJobList(payload).then(res => {
          resolve(res);
        });
      });
    },
    UploadJobFile({ commit }, payload) {
      return new Promise(resolve => {
        UploadJobFile(payload).then(res => {
          resolve(res);
        });
      });
    },
    FilePre({ commit }, payload) {
      return new Promise(resolve => {
        FilePre(payload).then(res => {
          resolve(res);
        });
      });
    },
    DelJob({ commit }, payload) {
      return new Promise(resolve => {
        DelJob(payload).then(res => {
          resolve(res);
        });
      });
    },
    GetUserJoibList({ commit }, payload) {
      return new Promise(resolve => {
        GetUserJoibList(payload).then(res => {
          resolve(res);
        });
      });
    },
    GetJoibStatus({ commit }, payload) {
      return new Promise(resolve => {
        GetJoibStatus(payload).then(res => {
          resolve(res);
        });
      });
    },
    GetJobPinCode({ commit }, payload) {
      return new Promise(resolve => {
        GetJobPinCode(payload).then(res => {
          resolve(res);
        });
      });
    },
  },
  mutations: {}
};
